import controller from './query-builder.controller';
import template from './query-builder.html';

export default {
	controller,
	template,
	bindings: {
		disabled:    '<?ngDisabled',
		group:       '<ngModel',
		options:     '<?',
		parentGroup: '<?',
		parentIndex: '<?',
	},
	require:  {
		children:    '^^?queryBuilderChildren',
		editor:      '^^?queryEditor',
		ngModelCtrl: 'ngModel',
		parent:      '^^?queryBuilder',
	},
};
